import { CurrencyTextField } from '@/common/components/CurrencyTextField'
import MaskedTextField from '@/common/components/MaskedTextField'
import { percentageMaskAllowNegative } from '@/common/constants/masks.constant'
import { ContractFeeData } from '@/common/types/contractFee.type'
import { formatCurrency, formatPercentage } from '@/common/utils/formatters'
import { FieldValues, Path, useFormContext } from 'react-hook-form'

interface FeeTextFieldProps<T> {
  contractFee: ContractFeeData
  disabled?: boolean
  fieldName: Path<T>
  errorMessage?: string
  submit: ({ id, value, calculate_as }: { id: string; value: string; calculate_as: string }) => void
  className?: string
}

export const FeeTextField = <T extends FieldValues>({
  contractFee,
  disabled,
  fieldName,
  errorMessage,
  submit,
  className,
}: FeeTextFieldProps<T>) => {
  const { register } = useFormContext<T>()

  return (
    <>
      {contractFee.fee_template.calculate_as === 'percentage' ? (
        <MaskedTextField
          mask={percentageMaskAllowNegative}
          label="Valor"
          value={contractFee.value ? formatPercentage(Number(contractFee.value)) : ''}
          className={className}
          {...register(fieldName)}
          errorMessage={errorMessage}
          onBlur={(e) => {
            if (!contractFee.fee_template) return
            submit({
              id: contractFee.id,
              value: e.target.value,
              calculate_as: contractFee.fee_template.calculate_as,
            })
          }}
          disabled={disabled}
        />
      ) : (
        <CurrencyTextField
          label="Valor"
          className={className}
          allowZero
          defaultValue={contractFee.value ? formatCurrency(Number(contractFee.value)) : ''}
          {...register(fieldName)}
          onBlur={(e) => {
            if (!contractFee.fee_template) return
            submit({
              id: contractFee.id,
              value: e.target.value,
              calculate_as: contractFee.fee_template.calculate_as,
            })
          }}
          errorMessage={errorMessage}
          disabled={disabled}
        />
      )}
    </>
  )
}
